/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelExtraPay.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "lme/powerbroker/extra-pay";

export class AutogenModelExtraPay<RowType extends ModelRow> extends Endpoint<RowType, RowExtraPayFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowExtraPay extends ModelRow<RowExtraPayFields> {
    constructor() {
        super(AutogenUserSavedSearchEndpoint);
    }
}

export interface RowExtraPayFields {
    amount: number;
    amount_c: string;
    amount_d: Date;
    amount_n: number;
    amount_r: number;
    carrier_rate_id: number;
    company_id: string;
    deduct_code_id: string;
    descr: string;
    detention_hist_pay_id: string;
    driver_id: string;
    entered_user_id: string;
    fuel_surcharge_pay: string;
    id: string;
    jag_rate_id: number;
    movement_id: string;
    order_id: string;
    payee_id: string;
    rate: number;
    reference_no: string;
    rev_uid: number;
    short_desc: string;
    transaction_date: Date;
    units: number;
}

